import { useId } from "react";

export function DataTableSection({
  actions = null,
  children,
  className = "",
  description = null,
  icon: Icon = null,
  title,
}) {
  const generatedHeadingId = useId();
  const headingId = `suite-data-table-section-${generatedHeadingId.replace(/:/g, "")}`;

  return (
    <section
      className={`suite-data-table-section ${className}`.trim()}
      aria-labelledby={headingId}
    >
      <header className="suite-data-table-section-header">
        <div className="suite-data-table-section-heading">
          {Icon && (
            <span className="suite-data-table-section-icon" aria-hidden="true">
              <Icon size={18} />
            </span>
          )}
          <div>
            <h2 id={headingId}>{title}</h2>
            {description && <p>{description}</p>}
          </div>
        </div>
        {actions && (
          <div className="suite-data-table-section-actions">{actions}</div>
        )}
      </header>
      {children}
    </section>
  );
}
